const CheckoutPage = () => {
    const main = document.getElementById('checkout');
    if (!main) {
        return;
    }
    const billingPrefix = '#billing-';
    const shippingPrefix = '#shipping-';

    const element = {
        billing: {
            id: $(`${billingPrefix}id`),
            existingAddress: $(`${billingPrefix}address`),
            firstName: $(`${billingPrefix}first_name`),
            lastName: $(`${billingPrefix}last_name`),
            company: $(`${billingPrefix}company`),
            country: $(`${billingPrefix}country`),
            city: $(`${billingPrefix}city`),
            state: $(`${billingPrefix}state`),
            streetAddress: $(`${billingPrefix}street_address`),
            zip: $(`${billingPrefix}zip`),
            email: $(`${billingPrefix}email`),
            phone: $(`${billingPrefix}phone`),
        },
        shipping: {
            id: $(`${shippingPrefix}id`),
            existingAddress: $(`${shippingPrefix}address`),
            firstName: $(`${shippingPrefix}first_name`),
            lastName: $(`${shippingPrefix}last_name`),
            company: $(`${shippingPrefix}company`),
            country: $(`${shippingPrefix}country`),
            city: $(`${shippingPrefix}city`),
            state: $(`${shippingPrefix}state`),
            streetAddress: $(`${shippingPrefix}street_address`),
            zip: $(`${shippingPrefix}zip`),
            email: $(`${shippingPrefix}email`),
            phone: $(`${shippingPrefix}phone`),
        },
        billingDifferentAddress: $('#billing-different-address'),
        billingDifferentAddressValue: $('#billing-diff-address'),
        formShipping: $('#form-shipping'),
        columnShippingAmount: $('#column-shipping-amount'),
        columnCartTotal: $('#column-cart-total'),
    };

    const findShippingAmount = (countryCode) => {
        axios.get(`/carts/shipping-amount?countryCode=${countryCode}`)
            .then((response) => {
                const { data } = response;

                element.columnShippingAmount.text(`${Dinero({ amount: data.amount }).toFormat()}`);
                element.columnCartTotal.text(`${Dinero({ amount: parseInt(data.total) }).toFormat()}`);
            })
            .catch((error) => {
                console.error(error);
            });
    }

    const findAddresses = (id, addressType) => {
        axios.get(`/addresses/${id}`)
            .then((response) => {
                const { data } = response;

                element[addressType].firstName.val(data.first_name);
                element[addressType].lastName.val(data.last_name);
                element[addressType].company.val(data.company);
                element[addressType].country.val(data.country);
                element[addressType].country.trigger('change');
                element[addressType].city.val(data.city);
                element[addressType].state.val(data.state);
                element[addressType].streetAddress.val(data.street_address);
                element[addressType].zip.val(data.zip);
                element[addressType].email.val(data.email);
                element[addressType].phone.val(data.phone);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const clearAddressInputs = (addressType) => {
        element[addressType].firstName.val('');
        element[addressType].lastName.val('');
        element[addressType].country.val('GB');
        element[addressType].country.trigger('change');
        element[addressType].city.val('');
        element[addressType].state.val('');
        element[addressType].streetAddress.val('');
        element[addressType].zip.val('');
        element[addressType].email.val('');
        element[addressType].phone.val('');
    };

    element.billing.existingAddress.change(function () {
        const value = parseInt($(this).val());

        element.billing.id.val(!value ? '' : value);

        if (!isNaN(value)) {
            findAddresses(value, 'billing');
        } else  {
            clearAddressInputs('billing');
        }
    });

    element.shipping.existingAddress.change(function () {
        const value = parseInt($(this).val());

        element.shipping.id.val(!value ? '' : value);

        if (!isNaN(value)) {
            findAddresses(value, 'shipping');
        } else {
            clearAddressInputs('shipping');
        }
    });

    element.billingDifferentAddress.change(function (e) {
        const isChecked = e.target.checked;

        if (isChecked) {
            element.billingDifferentAddressValue.val("1");
            element.formShipping.show();
        } else {
            element.billingDifferentAddressValue.val("");
            element.formShipping.hide();
        }
    });

    element.shipping.country.change(function () {
        const value = $(this).val();

        findShippingAmount(value);
    });
};

$(() => {
   CheckoutPage();
});

